import React from 'react'
import withStyles from 'react-jss'
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import compose from '@shopify/react-compose'
import classNames from 'classnames'

import Locales from 'components/locales'

import styles from './header-style'
import { assetUrlFor } from 'helpers/assets'
import withConfiguration from 'components/providers/configuration/with-configuration'
import withEndUser from 'components/providers/end-user/with-end-user'

const Header = ({ classes, user, portalConfiguration, logoutUser, handleChangeLocale, classType, children }) => {
  const { t } = useTranslation()

  const logoKey = portalConfiguration.theme === 'dark' && portalConfiguration.alt_logo_image_url ? 'alt_logo_image_url' : 'logo_image_url'
  const logo = assetUrlFor(portalConfiguration, logoKey)

  return (
    <header className={classNames(classes.header, classes[classType])}>
      <div className={classes.wrap}>
        <Link to='/' className={classes.logo} style={{ backgroundImage: `url(${logo})` }} />
        <Locales />
        {user.isEnabled() && user.isLoggedIn() && <button type="button" className={classes.user} onClick={user.logoutUser}>{t('layout.logout')}</button>}
      </div>
      {children}
    </header>
  )
}

Header.propTypes = {
  user: PropTypes.object,
  portalConfiguration: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  classType: PropTypes.string,
}

export default compose(
  withStyles(styles),
  withConfiguration,
  withEndUser,
)(Header)
